module.exports = __webpack_public_path__ + "static/img/qmwallet2-life-btn-bg.500b486e.png";